export default {
  API_URL: window.env.API_URL,
  REDIRECT_URI: window.env.REDIRECT_URI,
  CLIENT_ID: window.env.CLIENT_ID
}